module.exports = __webpack_public_path__ + "img/Intellipure-Compact.ba93075c.png";